import { combineReducers } from "redux-immutable";

import TrialsState from "../../../models/state/trials/TrialsState";
import wrongAnswersTrialStateReducer from "./wrongAnswers";

export default combineReducers(
  {
    wrongAnswers: wrongAnswersTrialStateReducer
  },
  () => new TrialsState() as any
);
